<template>
  <div class="message-box">
    <b-modal ref="modal-window" :title="$t('showHistoryAccounts.history-title', { name: name })" size="xl modal-fullscreen-xxl-down" modal-class="message-box-modal">
      <template #modal-body>
        <TableField
            v-model:params="params"
            :data="list"
            :columns="columns"
            :loading="loading"
            stickyHeader
            columnChooser
            mobileDevices
            section="history-accounts"
            @fetch-data="populateData"
        >
          <template #cell-date="{ value }">{{ formatDate(value) }}</template>
          <template #cell-trans="{ value }">
              <template v-if="value === 'paid'">
                <span class="badge rounded-pill bg-success">{{ $t('showHistoryAccounts.paid') }}</span>
              </template>
              <template v-else-if="value === 'issued'">
                <span class="badge rounded-pill bg-danger">{{ $t('showHistoryAccounts.invoice') }}</span>
              </template>
          </template>
          <template #cell-billingEnabled="{ value }">
            <template v-if="value">{{ $t('showHistoryAccounts.trackpro') }}</template>
            <template v-else>{{ $t('showHistoryAccounts.other') }}</template>
          </template>
          <template #cell-price="{ value }">{{ formatNumber(value) }}</template>
          <template #cell-priceCurrency="{ value }">{{ formatNumber(value) }}</template>
          <template #cell-balance="{ value }">{{ formatNumber(value) }}</template>
        </TableField>
      </template>

      <template #modal-footer>
        <span class="btn btn-secondary" @click="close()">{{ $t('client.cancel') }}</span>
      </template>
    </b-modal>
  </div>
</template>

<script src="./ShowHistoryAccounts.js"></script>